export const recommendedArticlesRoutes = {
  recommended: { proxy: 'articles/recommended', upstream: 'recommendations' },
} as const;
